<template>
  <a-layout-content>
    <div>
      <a-form layout="inline">
        <a-form-item label="分类名称">
          <a-input v-model="input.Name" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="query('Qry')"
            ><a-icon type="search"
          /></a-button>
        </a-form-item>
        <a-form-item>
          <a-alert message="流程说明" type="error">
           <template #description>
            <p>
              1.前端页面只会显示最新一期<br>
              2.排序最大即判别为"最新一期"继续减一即上一周期以此类推(请保持连号!)
            </p>
            </template>
           </a-alert>
          
        </a-form-item>
      </a-form>
    </div>
    <br />
    <a-table
      bordered
      size="small"
      row-key="ID"
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
      :loading="loading"
      :columns="columns"
      :data-source="datarow"
      :pagination="pagination"
      @change="changepage"
    >
      <template slot="title">
        <a-row :gutter="24">
          <a-col style="float: left">
            <span style="font-size: 15px">分类管理列表</span>
          </a-col>
          <a-col style="float: right">
            <a-tag color="red">
              <a href="javascript:;" @click="batchdelete()">
                <a-icon type="delete" style="font-size: 22px"></a-icon>
                <span style="font-size: 15px">批量删除</span>
              </a>
            </a-tag>
          </a-col>
          <a-col style="float: right">
            <a-tag color="yellow">
              <a href="javascript:;" @click="showmodel()">
                <a-icon type="plus" style="font-size: 22px"></a-icon>
                <span style="font-size: 15px">新增</span>
              </a>
            </a-tag>
          </a-col>
          <a-col style="float: right">
            <a-tag color="gray">
              <a href="javascript:;" @click="showSettingDays()">
                <a-icon type="setting" style="font-size: 22px"></a-icon>
                <span style="font-size: 15px">设定会员领取日期</span>
              </a>
            </a-tag>
          </a-col>
        </a-row>
      </template>
      <template slot="Operation" slot-scope="text, record">
        <a-tooltip title="编辑">
          <a @click="showmodel(record)">
            <a-icon type="edit" style="font-size: 22px"></a-icon>
          </a>
        </a-tooltip>
        &nbsp;&nbsp;
        <a-tooltip title="删除">
          <a @click="deleteMsg(record)">
            <a-icon type="delete" style="font-size: 22px"></a-icon>
          </a>
        </a-tooltip>
      </template>
    </a-table>

    <!--------------------------------------------------弹窗部份-------------------------------------------------->
    <a-modal
      v-model="visible"
      :title="title"
      width="35%"
      ok-text="提交"
      cancel-text="返回"
      @ok="save"
    >
      <a-form-model
        ref="ruleForm"
        :rules="rules"
        :model="edit"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="分类名称" ref="Name" prop="Name">
          <a-input v-model="edit.Name" placeholder="分类名称" />
        </a-form-model-item>
        <a-form-model-item label="排序字段" ref="Sort" prop="Sort">
          <a-input-number v-model="edit.Sort" placeholder="请输入排序" />
        </a-form-model-item>
        <br>
        <div style="color:red">
          *注意排序字段"最大数字"编号的即视为"最新一期",将会是会员申请规则依据,请警慎配置
        </div>
        <br>
        <br>
      </a-form-model>
    </a-modal>
    <!--------------------------------------------------弹窗部份-------------------------------------------------->

    <!--------------------------------------------------设定弹窗部份-------------------------------------------------->
    <a-modal
      v-model="settingvisible"
      :title="title"
      width="35%"
      ok-text="提交"
      cancel-text="返回"
      @ok="saveDailysetting"
    >
      <a-form layout="inline">
        <br /><br />
        <a-form-item label="可申请日期">
          <a-select
            mode="multiple"
            style="width: 500px"
            @change="handleChange"
            :value="edit.daily"
          >
            <a-select-option v-for="item in dailyoption" :key="item.key">
              {{ item.value }}
            </a-select-option>
          </a-select>
          <br />
          <br />
          <div style="color:red">选择前端可申请日期,EX:如选星期一可申请时间为(周一12点~周二12点)..以此类推</div>
          <br />
          <br />
        </a-form-item>
      </a-form>
    </a-modal>
    <!--------------------------------------------------设定弹窗部份-------------------------------------------------->
  </a-layout-content>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      datarow: [],
      columns: IninTable(),
      action: "",
      title: "",
      pagination: {
        total: 0,
        pageindex: 1,
        pagesize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true, // 可以改变每页个数
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        onShowSizeChange: (current, pageSize) => (this.pageSize = pageSize),
      },
      loading: false,
      visible: false,
      settingvisible: false,
      input: {
        Name: "",
        ID: 0,
      },
      edit: {
        ID: "0",
        Name: "",
        Sort: "1",
        daily: [],
      },
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      selectedRowKeys: [],
      dailyoption: [],
      rules: {
        Sort: [
          { required: true, message: "请输入排序", trigger: "blur" },
          { validator: this.validateInteger, trigger: "change" },
        ],
        Name: [
          { required: true, message: "请输入分类名称", trigger: "blur" },
          { validator: this.validateSql, trigger: "change" },
        ],
      },
    };
  },
  methods: {
    moment,
    //翻页
    changepage(e) {
      this.pagination.pageindex = e.current;
      this.pagination.pagesize = e.pageSize;
      this.query();
    },
    //批量选取
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    showmodel(record) {
      this.visible = true;
      if (stringIsNullorEmpty(record)) {
        this.action = "Add";
        this.clearinfo();
      } else {
        this.action = "Edit";
        let params = {
          ID: record.ID,
        };
        this.axios
          .post("/principal/getprincipaltermsetbyid", params)
          .then((res) => {
            if (res.data) {
              this.edit.ID = res.data[0].ID;
              this.edit.Name = res.data[0].Name;
              this.edit.Sort = res.data[0].Sort.toString();
            }
          });
      }
      this.title = this.action === "Add" ? "新增分类" : "编辑分类";
    },
    query() {
      let params = {
        Name: this.input.Name,
        pageindex: this.pagination.pageindex,
        pagesize: this.pagination.pagesize,
      };
      this.axios
        .post("/principal/getprincipaltermsetlist", params)
        .then((res) => {
          this.datarow = res.data;
          this.pagination.total = res.total;
        });
    },
    save() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = {
            ID: this.action === "Add" ? 0 : parseInt(this.edit.ID),
            Name: this.edit.Name,
            Sort: parseInt(this.edit.Sort),
          };
          let url =
            this.action === "Add"
              ? "/principal/addprincipaltermset"
              : "/principal/editprincipaltermset";

          this.axios.post(url, params).then((res) => {
            if (res.data) {
              this.$message.success(
                this.action === "Add" ? "新增成功" : "修改成功"
              );
              this.query();
              this.visible = false;
            } else {
              this.visible = false;
            }
          });
        } else {
          // 表单校验失败
          return false;
        }
      });
    },
    deleteMsg(record) {
      const that = this;
      this.$confirm({
        title: "删除数据",
        content: "您要确定要删除勾选数据吗?删除分类也会删除对应该期的排行榜所有导入数据!!",
        onOk() {
          let IDList = [];
          IDList.push({ ID: record.ID });
          let params = {
            IDList: IDList,
          };

          that.axios
            .post("/principal/deleteprincipaltermset", params)
            .then((res) => {
              if (res.data) {
                that.$message.success("删除成功");
                that.query();
              }
            });
        },
      });
    },
    batchdelete() {
      if (this.selectedRowKeys.length < 1 && type === 1) {
        this.$message.warning("请勾选数据");
        return;
      }

      let that = this;
      this.$confirm({
        title: "批量删除",
        content: "您要确定要删除勾选数据吗?删除分类也会删除对应该期的排行榜所有导入数据!!",
        onOk() {
          let IDList = [];
          that.selectedRowKeys.forEach((element) => {
            IDList.push({ ID: element });
          });
          that.axios
            .post("/principal/batchdeleteprincipaltermset", {
              IDList: IDList,
            })
            .then((res) => {
              if (res.data) {
                that.$message.success("删除成功");
                that.query();
              }
            });
        },
      });
    },
    clearinfo() {
      this.edit.Name = "";
      this.edit.Sort = "1";
    },
    showSettingDays() {
      this.dailyoption = [];
      this.settingvisible = true;
      this.dailyoption.push(
        {
          key: 1,
          value: "星期日",
        },
        {
          key: 2,
          value: "星期一",
        },
        {
          key: 3,
          value: "星期二",
        },
        {
          key: 4,
          value: "星期三",
        },
        {
          key: 5,
          value: "星期四",
        },
        {
          key: 6,
          value: "星期五",
        },
        {
          key: 7,
          value: "星期六",
        }
      );
    },
    handleChange(selectedItems) {
      this.edit.daily = selectedItems;
    },
    saveDailysetting() {
      let IDList = [];
      this.edit.daily.forEach((element) => {
        IDList.push({ ID: element });
      });

      this.axios
        .post("/principal/principalsetdaily", {
          IDList: IDList,
        })
        .then((res) => {
          if (res.data) {
            this.$message.success("操作成功");
            this.settingvisible = false;
          } else {
            this.settingvisible = false;
          }
        });
    },
    principalgetdaily() {
      this.axios.post("/principal/principalgetdaily", "").then((res) => {
        if (res.data) {
          let _this = this;
          let arr = res.data.split(",");
          arr.forEach(function (item, index) {
            _this.edit.daily.push(parseInt(item));
          });
        }
      });
    },
  },
  watch: {},
  //首次加载
  created() {
    this.query();
    this.principalgetdaily();
  },
};

const IninTable = function IninTable() {
  var header = [];

  header.push({ title: "ID", align: "center", width: 50, dataIndex: "ID" });
  header.push({
    title: "分类名称",
    align: "center",
    dataIndex: "Name",
  });
  header.push({
    title: "排序",
    align: "center",
    dataIndex: "Sort",
  });
  header.push({
    title: "操作",
    align: "center",
    scopedSlots: { customRender: "Operation" },
    width: 200,
  });

  return header;
};

function stringIsNullorEmpty(value) {
  return !value || value == undefined || value == "" || value.length == 0;
}

</script>


<style>
#editor1 {
  height: 200px;
}
.borderclass {
  border: 1px solid rgb(238, 229, 229);
}
</style>


// WEBPACK FOOTER //
// src/components/principal/principaltermset.vue